import api from './api'

export const algorithmicScannerService = {
  // Lista y CRUD de scanners
  listScanners: () => api.get('/algorithmic-scanner/configs'),
  createScanner: (data) => api.post('/algorithmic-scanner/configs', data),
  getScanner: (id) => api.get(`/algorithmic-scanner/configs/${id}`),
  updateScanner: (id, data) => api.put(`/algorithmic-scanner/configs/${id}`, data),
  deleteScanner: (id) => api.delete(`/algorithmic-scanner/configs/${id}`),

  // Acciones sobre un scanner
  runScan: (id) => api.post(`/algorithmic-scanner/configs/${id}/run`),
  diagnoseScan: (id) => api.post(`/algorithmic-scanner/configs/${id}/diagnose`),

  // Legacy: scanner por defecto (transición)
  getDefaultConfig: () => api.get('/algorithmic-scanner/config'),

  // Monte Carlo
  runMonteCarlo: (id, params) => api.post(`/algorithmic-scanner/configs/${id}/monte-carlo`, params),
  getMonteCarloResult: (resultId) => api.get(`/algorithmic-scanner/monte-carlo/results/${resultId}`),
  getMonteCarloRankings: () => api.get('/algorithmic-scanner/monte-carlo/rankings'),

  // Dashboard de rentabilidad
  getScannerDashboard: (id) => api.get(`/algorithmic-scanner/configs/${id}/dashboard`),
  getGlobalDashboard: () => api.get('/algorithmic-scanner/dashboard/global'),

  // Ranking de indicadores por señales
  getScannerIndicatorRankings: (id) => api.get(`/algorithmic-scanner/configs/${id}/indicator-rankings`),
  getGlobalIndicatorRankings: () => api.get('/algorithmic-scanner/indicator-rankings/global'),

  // Ranking de activos por señales
  getScannerAssetRankings: (id) => api.get(`/algorithmic-scanner/configs/${id}/asset-rankings`),
  getGlobalAssetRankings: () => api.get('/algorithmic-scanner/asset-rankings/global'),

  // Ranking de timeframes por señales
  getScannerTimeframeRankings: (id) => api.get(`/algorithmic-scanner/configs/${id}/timeframe-rankings`),
  getGlobalTimeframeRankings: () => api.get('/algorithmic-scanner/timeframe-rankings/global'),

  // Ranking de combinaciones indicador×activo×timeframe
  getScannerComboRankings: (id, minSignals = 3) =>
    api.get(`/algorithmic-scanner/configs/${id}/combo-rankings`, { params: { min_signals: minSignals } }),
  getGlobalComboRankings: (minSignals = 3) =>
    api.get('/algorithmic-scanner/combo-rankings/global', { params: { min_signals: minSignals } }),

  // Recomendaciones de ajuste de SL (simulación contrafactual)
  getScannerSlRecommendations: (id, groupBy = 'indicator', minSignals = 15) =>
    api.get(`/algorithmic-scanner/configs/${id}/sl-recommendations`, { params: { group_by: groupBy, min_signals: minSignals } }),
  getGlobalSlRecommendations: (groupBy = 'indicator', minSignals = 15) =>
    api.get('/algorithmic-scanner/sl-recommendations/global', { params: { group_by: groupBy, min_signals: minSignals } }),
}
